import { Component, ChangeDetectionStrategy, Input, OnInit, HostBinding, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable, Subject, BehaviorSubject, merge } from 'rxjs';
import { tap, switchMap, finalize, debounceTime, distinctUntilChanged, refCount, publishReplay } from 'rxjs/operators';
import { AdminProtocolsStorage, Protocol } from '../../../shared';

@Component({
    selector: 'protocol-search-select',
    template: require('./protocol-search-select.component.html'),
    styles: [require('./shared/select.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProtocolSearchSelectComponent implements OnInit {
    @Input()
    public control: FormControl;

    @Input()
    @HostBinding('class.disabled')
    public disabled = false;

    @Output()
    public protocolsChange = new EventEmitter<Protocol[]>();

    public selectedProtocols$: Observable<Protocol[]>;
    public protocols$: Observable<Protocol[]>;
    public readonly searchProtocolFlow$ = new Subject<string>();
    public readonly isSearchingForProtocols$ = new BehaviorSubject(false);

    constructor(private protocolsStorage: AdminProtocolsStorage) { }

    public ngOnInit() {

        this.selectedProtocols$ = this.control.valueChanges
            .pipe(
                distinctUntilChanged(), 
                publishReplay(1),
                refCount());

        this.protocols$ = merge(
            this.searchProtocolFlow$.pipe(
                debounceTime(300),
                distinctUntilChanged(),
                tap(() => this.isSearchingForProtocols$.next(true)),
                switchMap(protocolName => this.protocolsStorage.search(protocolName)),
                tap(() => this.isSearchingForProtocols$.next(false)),
                finalize(() => this.isSearchingForProtocols$.next(false))
            ),
            this.selectedProtocols$);

        this.control.setValidators(Validators.required);
        this.control.updateValueAndValidity();
    }

    public onProtocolsChange(selectedProtocols: Protocol[]) {
        this.control.setValue(selectedProtocols);
        this.protocolsChange.emit(selectedProtocols);
    }
}